import { createFileRoute } from '@tanstack/react-router';
import { AdminTailgateCostCbmPage } from '@/features/admin/admin-tailgate-cost-cbm-page';

export const Route = createFileRoute('/admin/tailgate-cost-cbm')({
  component: AdminTailgateCostCbmRoute,
});

function AdminTailgateCostCbmRoute() {
  return <AdminTailgateCostCbmPage />;
}
